// extracted by mini-css-extract-plugin
export default {"root":"BlurbToAction_root__1nggW","blurb":"BlurbToAction_blurb__30PlL","cta":"BlurbToAction_cta__cZGEm"};